import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { driverModel } from '~/entities/common/Driver'
import { usePermissions } from '~/entities/common/viewer'
import { Button } from '~/shared/ui/Buttons'
import { PlusIcon } from '~/shared/ui/Icons'
import { useModal } from '~/shared/ui/Modal'
import { TravelSheetCreateModal } from '../TravelSheetCreateModal'

export const TravelSheetCreate = () => {
  const { t } = useTranslation()

  const { canTravelSheetsCreate } = usePermissions()
  const {
    isModalShow: isTravelSheetCreateModalShow,
    openModal: openTravelSheetCreateModal,
    closeModal: closeTravelSheetCreateModal,
  } = useModal()

  const isLoading = useStore(driverModel.requestDriverFx.pending)

  return (
    <>
      <Button
        show={canTravelSheetsCreate}
        onClick={openTravelSheetCreateModal}
        startDecorator={<PlusIcon />}
        variant='brand'
        loading={isLoading}
      >
        {t('button.generate')}
      </Button>
      <TravelSheetCreateModal
        isShow={isTravelSheetCreateModalShow}
        onClose={closeTravelSheetCreateModal}
      />
    </>
  )
}
